import { useEffect, useState, useMemo } from "react";
import * as moment from "moment";
import { Moment } from "moment";

const useCountDown = ({ dateTo }: { dateTo: Moment }) => {
  const [currentTime, setCurrentTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const updateDate = () =>
    setTimeout(() => {
      const days = moment(dateTo).diff(moment(), "days");
      const hours = moment(dateTo).diff(moment(), "hours") - days * 24;
      const minutes =
        moment(dateTo).diff(moment(), "minutes") - days * 24 * 60 - hours * 60;
      const seconds =
        moment(dateTo).diff(moment(), "seconds") -
        days * 24 * 60 * 60 -
        hours * 60 * 60 -
        minutes * 60;

      setCurrentTime({ days, hours, minutes, seconds });
    }, 1000);

  const finishedCountdown = useMemo(
    () =>
      currentTime.days < 1 &&
      currentTime.hours < 1 &&
      currentTime.minutes < 1 &&
      currentTime.seconds < 1,
    [currentTime]
  );

  useEffect(() => {
    const callback = updateDate();

    return () => clearTimeout(callback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime]);

  return { currentTime, finishedCountdown };
};

export default useCountDown;
